/**
 * Social Proof Features
 * - "X sold in last Y hours" 
 * - "X customers are viewing this product"
 */

(function() {
  'use strict';

  // Initialize sold in last feature
  function initSoldInLast() {
    const wrappers = document.querySelectorAll('[data-sold-out-product]');
    
    wrappers.forEach(function(wrapper) {
      if (wrapper.classList.contains('soldout')) return;
      
      const itemData = wrapper.getAttribute('data-item');
      const hoursData = wrapper.getAttribute('data-hours');
      
      if (itemData && hoursData) {
        const numbersProductList = itemData.toString().split(',');
        const numbersHoursList = hoursData.toString().split(',');
        
        const randomProductIndex = Math.floor(Math.random() * numbersProductList.length);
        const randomHoursIndex = Math.floor(Math.random() * numbersHoursList.length);
        
        const numberEl = wrapper.querySelector('[data-sold-out-number]');
        const hoursEl = wrapper.querySelector('[data-sold-out-hours]');
        
        if (numberEl) numberEl.textContent = numbersProductList[randomProductIndex];
        if (hoursEl) hoursEl.textContent = numbersHoursList[randomHoursIndex];
        
        wrapper.style.display = '';
      }
    });
  }

  // Initialize customer viewing feature
  function initCustomerViewing() {
    const wrappers = document.querySelectorAll('[data-customer-view]');
    
    wrappers.forEach(function(wrapper) {
      if (wrapper.classList.contains('soldout')) return;
      
      const viewerData = wrapper.getAttribute('data-customer-view');
      const timeData = wrapper.getAttribute('data-customer-view-time');
      
      if (viewerData) {
        const viewerList = viewerData.toString().split(',').map(Number);
        const updateTime = (parseInt(timeData) || 5) * 1000;
        
        function updateViewerCount() {
          const randomIndex = Math.floor(Math.random() * viewerList.length);
          const numberEl = wrapper.querySelector('[data-customer-view-number]');
          if (numberEl) numberEl.textContent = viewerList[randomIndex];
        }
        
        // Set initial value
        updateViewerCount();
        
        // Update periodically
        setInterval(updateViewerCount, updateTime);
      }
    });
  }

  // Initialize on DOM ready
  function init() {
    initSoldInLast();
    initCustomerViewing();
  }

  // Run on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section events (for theme editor)
  document.addEventListener('shopify:section:load', init);
  
  // Re-initialize on quick view open (if applicable)
  document.addEventListener('theme:quickview:open', init);
})();
